import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../Firebase";

const ProjectsSection = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      const querySnapshot = await getDocs(collection(db, "projects"));
      const projectsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProjects(projectsData);
    };

    fetchProjects();
  
  }, []);
console.log("Proects Section here ",projects);
  return (
    <section className="py-16 text-white bg-gray-900" id="projects">
      <div className="container px-6 mx-auto">
        <h2 className="mb-12 text-4xl font-bold text-center">My Projects</h2>
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {projects.map((project) => (
            <motion.div
              key={project.id}
              whileHover={{ scale: 1.05 }}
              className="overflow-hidden transition-transform duration-300 bg-gray-800 shadow-lg rounded-xl"
            >
              <img
                src={project.image}
                alt={project.title}
                className="object-cover h-48 rounded-none w-fit "
                
              />
              <div className="p-6">
                <h3 className="mb-2 text-2xl font-semibold">{project.title}</h3>
                <p className="mb-4 text-gray-300">{project.description}</p>
                <a
                  href={project.demoLink}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-block px-4 py-2 transition bg-blue-600 rounded-lg hover:bg-blue-700"
                >
                  Live Demo 🚀
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
